const productGuide = [
	{
		name: "Comissioning Labels",
		description:
			"The process of publishing labels used to identify a product, a package or shipment",
		steps: {
			automatic: [
				"click on commission labels from the home page",
				"it is set to 'automatic' by default",
				"click on field that says 'scan barcode'",
				"use a barcode scanner to scan the barcode on the already printed label attached to the product",
				"the barcode details will be sent immediately to GS1",
			],
			batch: [
				"click on commission labels from the home page",
				"click on the tab with the label 'Batch' at the top",
				"click on field that says 'scan barcode'",
				"use a barcode scanner to scan the barcode on the already printed label attached to the product",
				"continue scanning all required barcodes to be commisioned",
				"then click the 'submit' button after you are done with scanning",
			],
		},
		note: "all labels must be commisioned before being used for packing or shipping or any other process below",
	},
	{
		name: "Pack Products",
		description:
			"The process of packing single product unit together, or packing already packed products in a larger package or packing for shipment labels used to identify a product, a package or shipment",
		steps: {
			base: [
				"click on Pack Products from the home page",
				"type in the number of products to be packed or number of packages to be packed",
				"click the 'OK' button to proceed",
				"click on field that says 'scan barcode' under the 'scan parent' text",
				"use a barcode scanner to scan the barcode of the main package that will contain other packs or products",
				"the field to scan the children will be displayed",
				"click on field that says 'scan barcode' under the 'scan children' text",
				"use a barcode scanner to scan the barcode of the products or packages that will be in the  main package",
				"continue scanning all required barcodes of the products",
				"the barcode details will be sent immediately to GS1",
			],
		},
		note: "all products must be packed with your sscc generated barcode before shipping",
	},
	{
		name: "Ship Packages",
		description:
			"The process of shipping products with already commissioned labels",
		steps: {
			automatic: [
				"click on ship package from the home page",
				"it is set to 'automatic' by default",
				"click on field that says 'scan barcode'",
				"use a barcode scanner to scan the SSCC barcode for the shipment",
				"the barcode details will be sent immediately to GS1",
			],
			batch: [
				"click on ship package from the home page",
				"click on the tab with the label 'Batch' at the top",
				"click on field that says 'scan barcode'",
				"use a barcode scanner to scan the SSCC barcode for the shipment",
				"continue scanning all required SSCC barcodes to be shipped",
				"then click the 'submit' button after you are done with scanning",
			],
		},
		note: "all labels must be commisioned before being used for packing or shipping or any other process below",
	},
];

//For testing purposes, this list of permissions will be used to determine which features a user can access based on their assigned permissions.
const accessiblePermissions = [
	"CREATE_CLIENT",
	"DELETE_CLIENT",
	"EDIT_CLIENT",
	"MANAGE_TRADE_PARTNER",
	"VIEW_TRADE_PARTNER",
	"VIEW_CLIENT",
	"CREATE_COMMISSION",
	"DOWNLOAD_COMMISSION",
	"VIEW_COMMISSION",
	"CREATE_DECOMMISSION",
	"VIEW_DECOMMISSION",
	"DISPENSE_LABEL",
	"VIEW_DISPENSING",
	"CREATE_EVENT_FILTER",
	"DELETE_EVENT_FILTER",
	"EDIT_EVENT_FILTER",
	"VIEW_EVENT_FILTER",
	"CHECK_LABEL",
	"VIEW_LABEL",
	"VIEW_LABEL_TABLE",
	"CREATE_LOCATION",
	"DELETE_LOCATION",
	"EDIT_LOCATION",
	"VIEW_LOCATION",
	"CREATE_LOTNUMBER",
	"VIEW_LOTNUMBER",
	"PACK_LABEL",
	"DOWNLOAD_PACKING",
	"VIEW_PACKING",
	"QUEUE_SGTIN",
	"QUEUE_SSCC",
	"VIEW_QUEUE",
	"RECEIVE_LABEL",
	"VIEW_RECEIVING",
	"CREATE_ROLE",
	"DELETE_ROLE",
	"EDIT_ROLE",
	"MANAGE_ROLE_PERMISSIONS",
	"VIEW_ROLE",
	"SHIP_LABEL",
	"VIEW_SHIPPING",
	"VIEW_SUMMARY",
	"UNPACK_LABEL",
	"VIEW_UNPACKING",
	"CREATE_USER",
	"DELETE_USER",
	"EDIT_USER",
	"MANAGE_USER_CLIENTS",
	"MANAGE_USER_ROLES",
	"VIEW_USER",
];

export { productGuide, accessiblePermissions };
